// Supports weights 100-900
import "@fontsource-variable/noto-sans-jp";
import "./index.css";
import "../i18n/config"

import { Toaster } from "react-hot-toast";
import { Outlet } from "react-router-dom";
import SWRProivder from "./SWRProvider";

function Root() {
  return (
    <SWRProivder>
      <Toaster position="bottom-right" />
      <Outlet />
    </SWRProivder>
  );
}

export default Root;
